<template>
  <RequestWizardStep name="Medicare Status"
    :complete="isEnrolled"
  >
    <ContentCard
      :title="'Great! Let\'s make sure you\'re still in the right place to get the records you'
        + ` are requesting ${is3rdParty ? 'on behalf of someone else' : 'for yourself'}.`"
    >
      <div>
        <AlertMessage type="warning" :show="isEnrolled === false" title="Medicare Enrollment">
          <p>Uh-oh! If {{ is3rdParty ? 'the individual is' : 'you are' }} not enrolled in
            Medicare, this is not the correct online request submission form for you. Let's get
            you back to the
            <a target="_blank"
              href="https://www.cms.gov/center/freedom-of-information-act-center.html"
            >Centers for Medicare and Medicaid Services' main FOIA website</a>.
          </p>

          This online request form is strictly for obtaining claims records for a person currently
          enrolled in Medicare.
        </AlertMessage>

        <RadioButtons
          :label="(is3rdParty
            ? 'The individual is enrolled in Medicare or was previously enrolled in Medicare'
            : 'I am enrolled in Medicare') + ':'"
          :options="[
            { label: 'Yes', value: true },
            { label: 'No', value: false }
          ]"
          v-model="isEnrolled"
        />
      </div>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import RadioButtons from '@/components/formFields/RadioButtons';
import AlertMessage from '@/components/AlertMessage';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';
import { is3rdParty } from '../requestWizardState';

export default {
  setup: () => ({ is3rdParty }),

  components: {
    RadioButtons, AlertMessage, RequestWizardStep
  },

  data: () => ({
    isEnrolled: null
  })
};
</script>
